import OrganizationInviteSuccessModal from './OrganizationInviteSuccessModal';

export default OrganizationInviteSuccessModal;
